import { ApiBase } from '@/api/api'
import { makePostRequest } from '@/api/fetchCalls'
import { CreateMessageProps, Message } from '@/types/message'

export async function createMessage(
  data: CreateMessageProps
): Promise<Message> {
  const payload = {
    target_email: data.email,
    target_phone: data.phoneNumber,
    customer: data.customerId,
    message_type: data.messageType,
    form: data.formId,
    packet: data.packetId,
    document: data.documentId,
    team: data.teamId,
    preferred_delivery_method: data.preferredDeliveryMethod,
    delivery_method_used: data.deliveryMethodUsed,
    is_waiting: data.isWaiting,
    scheduled_at: data.scheduledDate,
  }

  // Remove null values
  Object.keys(payload).forEach(
    (key) =>
      payload[key as keyof typeof payload] === null &&
      delete payload[key as keyof typeof payload]
  )
  if (!payload.form && !payload.packet && !payload.document) {
    throw new Error('Either formId, packetId, or documentId must be provided')
  }

  return await makePostRequest(`${ApiBase}/message`, {
    body: JSON.stringify(payload),
  })
}
